var theCaptions = [
[2, "What is the sell-by-date of a book?"],
[6, "Do books like guests and fish begin to smell after three days?"],
[11, "Or three centuries?"],
[14, "They too die when they are old and far away,"],
[19, "or underwater."],
[21, "Thomas Booker, a vegetarian marine biologist who copied long passages"],
[28, "of his dissertation on cetacean biology from Moby Dick,"],
[34, "vanished while on a research mission."],
[37, "Breaking with his usual habits, he had caught and eaten a sarpa salpa fish"],
[44, "in an effort to feel closer to his obsessions,"],
[48, "then experienced several days of hallucinations before disappearing."],
[54, "His body was never found."],
[58, "All his life, Thomas Booker had studied fish by the books."],
[65, "Books die in water, fish die out of it. You see, they are the same."],
[74, "Fish like books circulate and are consumed. They’re mysterious and fished for."],
[82, "They school together, and many of them are about the same size."],
[87, "Every bored reader has found herself trawling the library stacks"],
[94, "hoping for something exotic to catch her eye, bite at her interest,"],
[100, "surface an idea like a little squirt in the dark, or a fish."],
[107, "A fish is an emblem of a vanishing world, like a beautiful image in a book,"],
[114, "or a meal-sized picture."],
[117, "People who keep aquaria and computer screens in their homes"],
[123, "put something strange, watery, and exotic on display."],
[128, "They’re collectors, like bibliophiles, or nineteenth-century fishermen"],
[135, "hauling whole libraries of fish back to Europe.	"],
[139, "Not everyone can be a mariner. Not all of us go to sea."],
[146, "But still, acquaintance with the fishes holds an appeal. A captivation."],
[154, "It is an effort for the ambitious to pursue."],
[158, "They look in books for hundred-year-old windows on the ocean bottom."],
[165, "Salted down, dried and preserved between the pages of a book,"],
[171, "fish were made visible for the landlocked."],
[175, "This was fine, so long as no one ate the book."],
[181, "A rare book library is a ship ferrying to the future’s horizon, a palm holding objects beset by time,"],
[191, "each one tiny and strong next to the endless oceans of drowned and vanished books,"],
[199, "and the spaces and times of no books at all."],
[203, "By now, though, we are familiar with the bottom-trawling hubris"],
[209, "of trying to plumb the depths, scour out the sea."],
[214, "It is the wrong approach to a library, as though you could read every book,"],
[220, "or taste the internet."],
[223, "Fish and print have made us what we are."],
[227, "Fish to spread the hunger for the sea, and the sea to spread the book."],
[234, "Without the sail and the press, would we be quite as we are today?"],
[240, "Would we be quite so much at sea?"],
[244, "I have been told that Thomas Booker’s final effort was to catalogue his findings"],
[251, "in an aquarium of books and fish that could be kept together."],
[256, "Like Noah, he wanted to preserve the fish by naming them,"],
[262, "to keep them all afloat, so that, despite their departure from the seas,"],
[269, "by staring at an aquarium, or a page, or a screen, we might find them again."],
[279, "There are some who insist that his fish collection has been"],
[284, "preserved in a Toronto archive at the behest of a wealthy donor,"],
[289, "but for now, aside from the books collected here,"],
[294, "it must be known as the missing rare fish library."],
[299, "Now you see, it is a fine and lovely day for a sail."],
[304, "Why not build an aquarium of books for your home."],
[309, "Fill it with water, and put it on display."]
]

export default theCaptions

